var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"snackbar-container",style:({ 'background': _vm.bgColor })},[_c('div',{staticClass:"card"},[_c('p',[_vm._v(_vm._s(_vm.text))]),_c('i',{staticClass:"icon-close",on:{"click":_vm.hide}})]),_c('div',{staticClass:"progress-bar"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }